import type { ModuleRegisterFunction } from "@sg-protect/shell";

export const registerMswRequestHandlers: ModuleRegisterFunction = async runtime => {
    // Files including an import to the "msw" package are included dynamically to prevent adding
    // MSW stuff to the bundle when it's not used.
    if (runtime.isMswEnabled) {
        const requestHandlers = (await import("./handlers.ts")).handlers;

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        requestHandlers.forEach(handler => Object.assign(handler, { mockModule: "shell" }));

        runtime.registerRequestHandlers(requestHandlers);
    }
};
